import Api from '../../shared/Api';

class PlanEditorOrdersApi {
    static getPlanOrders(): Promise<any> {
        return new Api().get('/views/planeditor/orders');
    }

    static grabPlanOrder(planOrderId: number): Promise<any> {
        return new Api().put(`/views/planeditor/orders/${planOrderId}/grab`, {});
    }

    static editPlanOrder(planOrderId: number): Promise<any> {
        return new Api().put(`/views/planeditor/orders/${planOrderId}/edit`);
    }

    static deletePlanOrderExternalFile(planOrderId: number, fileInfoId: number): Promise<any> {
        return new Api().delete(`/views/planeditor/orders/${planOrderId}/file/${fileInfoId}`);
    }

    static deletePlanOrderStoreyExternalFile(
        planOrderId: number,
        planOrderStoreyId: number,
        fileInfoId: number
    ): Promise<any> {
        return new Api().delete(
            `/views/planeditor/orders/${planOrderId}/file/${fileInfoId}/storey/${planOrderStoreyId}`
        );
    }

    static approvePlanOrder(planOrderId: number) {
        return new Api().post(`/views/planeditor/orders/${planOrderId}/approve`, {});
    }

    static generateFiles(planOrderId: number) {
        return new Api().post(`/views/planeditor/orders/${planOrderId}/generate`, {});
    }

    static downloadFiles(planOrderId: number) {
        return new Api().downloadFile(`/views/planeditor/orders/${planOrderId}/download`);
    }

    static updatePlanEditor(planOrderId: number, planEditorId: number): Promise<any> {
        return new Api().put(`/views/planeditor/orders/${planOrderId}/planeditor`, {
            planEditorId: planEditorId
        });
    }

    static createEmptyStorey(planOrderId: number) {
        return new Api().post(`/views/planorder/${planOrderId}/storey/empty`, {});
    }

    static updatePlanOrderStoreySort(planOrderId: number, storey: any): any {
        return new Api().put(`/views/planorder/${planOrderId}/storey/sort`, storey);
    }

    static deleteStorey(planOrderId: number, storeyId: number): any {
        return new Api().delete(`/views/planorder/${planOrderId}/storeys/${storeyId}`);
    }

    static updateStorey(planOrderId: number, planOrderStoreyId: number, data: any): any {
        return new Api().put(`/views/planorder/${planOrderId}/storey/${planOrderStoreyId}`, data);
    }

    static deleteDeliveryFile(reference: string) {
        return new Api().delete(`/views/planorder/deliveryfile/${reference}`);
    }
}

export default PlanEditorOrdersApi;
